import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
export function ErrorAlert() {
    const message = t({
        message: 'Something went wrong',
        comment: 'invites table: error alert',
    });
    return <Alert message={message} appearance="danger"/>;
}
